export const delay = (ms) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(undefined)
    }, ms)
  })
}

export const chunkArray = (array, size) => {
  const chunks = [];
  
  for (let i = 0; i < array.length; i += size) {
    chunks.push(array.slice(i, i + size));
  }
  
  return chunks;
}

export const getBase64FromUri = async (uri) => {
  const response = await fetch(uri)
  const blob = await response.blob()

  const base64 = await new Promise((resolve, reject) => {
    const reader = new FileReader()

    reader.onerror = reject
    reader.onload = () => {
      resolve(reader.result)
    }

    reader.readAsDataURL(blob)
  })

  return base64
}

export const capitalizeText = (value) => {
  const text = value.toLowerCase()
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()
}

export const truncateText = (text, limit) => {
  if (text.length > limit) {
    return text.slice(0, limit) + '...'
  }

  return text
}

export function debounce(func, delay) {
  if (typeof func === 'function' && typeof delay === 'number') {
    let timeoutId = null;
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func();
    }, delay);
    return;
  }

  let timeoutId;

  return function (...args) {
    const context = this;

    clearTimeout(timeoutId);

    timeoutId = setTimeout(() => {
      func.apply(context, args);
    }, delay);
  };
}
